import axios from 'axios'
import moment from 'moment'
import tracker from "../common/tracker"
import { captureException } from "../common/error"
import { inIframe } from "./common"

const MAXRETRY = 4

const allowedPaths = [
  '/contact',
  '/mission',
  '/team',
  '/login',
  '/signup',
  '/activated',
  '/reset',
]

const pathMatch = (path) => {
  for (let i = 0; i < allowedPaths.length; i++) {
    if (path.substr(0, allowedPaths[i].length) === allowedPaths[i])
      return true
  }
  return false
}

function retryFailedRequest (err) {
  if (err.response && err.response.status < 500) {
    throw err
  }
  if (err.config && (!err.config.__retryCount || err.config.__retryCount < MAXRETRY) && !(err.response && err.response.status !== 503 && err.response.data)) {
    console.log(JSON.stringify(err.response))
    err.config.__retryCount = err.config.__retryCount ? err.config.__retryCount + 1 : 1;
    return new Promise((resolve, reject) => {
      setTimeout(
          () => axios(err.config).then(x => resolve(x)).catch(e => reject(e)),
          err.config.__retryCount * 1000
      )
    })
  }
  throw err;
}
axios.interceptors.response.use(undefined, retryFailedRequest);

const OK_SIGNALS = ['ok', 'OK', 'DONE', 'INPUT_REQUEST', 'SERIOUS', 'LOCATION_NEEDED', 'MEMBERSHIP_NEEDED']

const post = (url, args) => {
  return http(url, 'POST', args).then(data => {
    if (!data.status ||
        (!data.statusText && !OK_SIGNALS.contains(data.status)) ||
        (data.statusText && !OK_SIGNALS.contains(data.statusText))) {
      throw data
    } else {
      return data
    }
  }).catch(captureException)
}

const argsToForm = (args) => {
  let data = new FormData()
  Object.keys(args).forEach((key) => {
    if (args.hasOwnProperty(key) && args[key] !== null && args[key] !== undefined) {
      if (Object.keys(args[key]).length > 0 && args[key].constructor === Object) {
        data.append(key, JSON.stringify(args[key]))
      } else {
        data.append(key, args[key])
      }
    }
  })
  if (window.sessionid) {
    data.append('sessionid', window.sessionid)
  }
  return data
}

const http = (url, method, args, noCache=false, returnData=true, trackResponseTime=false, trackingLabel='') => {
  let data = args ? argsToForm(args) : undefined
  let headers = {'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'}

  if (noCache) {
    headers['Cache-Control'] = 'no-cache'
  }

  if (inIframe()) {
    headers["X-IN-IFRAME"] = 'true'
  }

  const locale = localStorage.getItem("locale")

  if (locale === "es-us") {
    headers["Accept-Language"] = "es,es-US;q=0.9,en-US;q=0.8,en;q=0.7"
  }

  if ((method === 'GET' || method === 'DELETE') && window.sessionid) {
    const delimeter = url.indexOf('?') > -1 ? '&' : '?'
    url = url + delimeter + 'sessionid=' + window.sessionid
  }

  const startTime = moment()

  return axios({
    method: method,
    url: url,
    data: data,
    withCredentials: true,
    maxRedirects: 0,
    headers: headers
  }).then(r => {

    if (trackResponseTime) {
      const responseTime = Math.round(moment().diff(startTime, 'seconds', true))
      tracker.apiResponseTime(url, responseTime, trackingLabel)
    }

    // when the browser automatically performs a redirect, test to see if the
    // site should redirect as well by comparing the request URL and the
    // response URL. Redirect when the responseURL is a valid page.
    if (r.status === 503) {
      window.location = '/unavailable'
    }
    let responseURL, relativeURL
    if (r.request.responseURL) {
      responseURL = r.request.responseURL.replace(/%3D/g, '=')
      relativeURL = responseURL.slice(responseURL.indexOf('/', 8))
    }
    let queryParams = ''
    if (responseURL && responseURL.includes('?')){
        let queryIndex = relativeURL.indexOf('?')
        queryParams = relativeURL.slice(queryIndex)
        relativeURL = relativeURL.slice(0,queryIndex)
    }
    if (relativeURL && url !== (relativeURL+queryParams) &&
        pathMatch(relativeURL) && window.location.href.indexOf('app=true') < 0){
      window.location = relativeURL + queryParams
    }
    else if (r.headers && r.headers.location) {
      r.data.location = r.headers.location
    }
    if (r.data && r.data.sessionid) {
      window.sessionid = r.data.sessionid
    }
    return returnData && r.data ? r.data : r
  })
}

export {post as default, http}



// WEBPACK FOOTER //
// ./assets/common/post.js